import { dismissToast, ui } from './ui.js';
import { tryAgain, undo } from './actions.js';
import { useEngineState } from './engine-state.js';
import { exportLog } from './files.js';

/** The message after a correction, with Undo. It sits at the top of the stage, over the status line, so it covers no control. */
export function Toast() {
  const { toast } = ui.use();
  const s = useEngineState();
  if (!toast) return null;
  // Undo cancels the last change in force, so it is only offered while this toast's change is still the last one.
  const offer = toast.undo && s.events.length === toast.events && !s.truthMode;
  return (
    <div class="toast" data-toast>
      <span>{toast.message}</span>
      {offer && (
        <button type="button" class="btn quiet" onClick={() => { undo(); }}>
          Undo
        </button>
      )}
      <button type="button" class="btn quiet icon" aria-label="Dismiss" onClick={dismissToast}>
        ×
      </button>
    </div>
  );
}

/**
 * Something failed that the dancer must know: the taps are not being saved, or the analysis or the player failed. Persistent, plain, with
 * the action that may help. It sits under the bar, outside the stage, so it covers no control and is not taken for a tap.
 */
export function Problems() {
  const s = useEngineState();
  if (!s.saveError && !s.trouble) return null;
  return (
    <div class="problems" role="group" aria-label="Problems">
      {s.saveError && (
        <div class="problem" data-testid="problem-save">
          <span>{s.saveError}</span>
          <button type="button" class="btn" onClick={() => void exportLog()}>Export my taps now</button>
        </div>
      )}
      {s.trouble && (
        <div class="problem" data-testid="problem-trouble">
          <span>{s.trouble.message}</span>
          {s.trouble.action === 'reload'
            ? <button type="button" class="btn" onClick={() => location.reload()}>Reload</button>
            : <button type="button" class="btn" onClick={() => void tryAgain()}>Try again</button>}
        </div>
      )}
    </div>
  );
}

/** The polite live region: state changes ("Counting from your taps") are spoken here. */
export function LiveRegion() {
  const { announcement } = ui.use();
  return <div class="sr-only" role="status" aria-live="polite">{announcement}</div>;
}
